import React from 'react'
import { Accordion, Badge, Form } from 'react-bootstrap'
import { marked } from 'marked'
import Portal from '@/types/Portal'
import QuestionAnswer from '@/types/QuestionAnswer'

interface Props {
  qa: QuestionAnswer
  portal?: Portal
  onTogglePublished: (qa: QuestionAnswer, isPublished: boolean) => void
}

export default function QuestionAnswerAccordionItem({
  qa,
  portal,
  onTogglePublished,
}: Props) {
  return (
    <Accordion.Item eventKey={String(qa.id)} className="border rounded-3 mb-3 overflow-hidden">
      <Accordion.Header>
        <div className="d-flex align-items-center justify-content-between gap-3 w-100 pe-2">
          <span dangerouslySetInnerHTML={{ __html: marked.parseInline(`Question: ${qa.question}`) }} />
          {portal && qa.mine && (
            <div
              className="d-inline-flex justify-content-end"
              style={{ minWidth: '14rem' }}
              onClick={(e) => e.stopPropagation()}
            >
              <Form.Check
                className="d-inline-flex align-items-center m-0"
                checked={qa.published}
                type="switch"
                id={`qa-published-switch-${qa.id}`}
                label={qa.published ? 'Visible to everyone' : 'Visible only to you'}
                onChange={e => onTogglePublished(qa, e.target.checked)}
              />
            </div>
          )}
        </div>
      </Accordion.Header>
      <Accordion.Body>
        <div dangerouslySetInnerHTML={{ __html: marked(`Answer: ${qa.answer}`) }} />

        {portal && qa.projects && qa.projects.length > 0 && (
          <>
            <hr className="border-secondary border-1" />
            <div className="d-flex flex-wrap gap-2">
              {qa.projects.map(({ title }) => (
                <Badge
                  key={title}
                  bg="primary"
                >
                  {title}
                </Badge>
              ))}
            </div>
          </>
        )}
      </Accordion.Body>
    </Accordion.Item>
  )
}
